//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SecondaryButton from '@/components/shared/secondary-button'
import {mapActions} from 'vuex'
export default {
  name: 'ForgotPasswordDialog',
  components: {SecondaryButton},
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data: (vm) => {
    return {
      forgotPasswordForm: {
        username: '',
      },
      valid: true,
    }
  },
  methods: {
    ...mapActions('common/gridSetting', ['saveGridSetting']),
    close() {
      this.$emit('close', false)
    },
    async resetPassword() {
      if (
        this.$refs.forgetPasswordForm &&
        this.$refs.forgetPasswordForm.validate()
      ) {
        try {
          const response = await this.$axios.post('auth/forgotPassword', {
            Username: this.forgotPasswordForm.username,
          })

          if (response.status === 200) {
            if (response.data.apiMessages.hasErrors) {
              this.$toast.error(
                response.data.apiMessages.serverErrors.join(' \n')
              )
            } else {
              this.$toast.success(
                response.data.apiMessages.successMessages.join(' \n')
              )
            }
          } else {
            this.$toast.error(
              'There was an error resetting the password for the user! Error code: ' +
                response.status
            )
          }
        } catch (err) {
          this.$toast.error(
            'There was an error resetting the password for the user!'
          )
        }
      }
    },
  },
}
